module.exports = __webpack_public_path__ + "images/d83ef80ad9e7c2a1b83156606fe314aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/intro_video/ksenia_mobile.jpg
// module id = 146
// module chunks = 24